// test428
(428 && 0);
